var React = require('react');

function CircleSendInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"white","key":0}),React.createElement("path",{"d":"M21.51 17.2301L30.07 21.5101C33.91 23.4301 33.91 26.5701 30.07 28.4901L21.51 32.7701C15.75 35.6501 13.4 33.2901 16.28 27.5401L17.15 25.8101C17.37 25.3701 17.37 24.6401 17.15 24.2001L16.28 22.4601C13.4 16.7101 15.76 14.3501 21.51 17.2301Z","stroke":"#0A9E50","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M17.44 25H22.84","stroke":"#0A9E50","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CircleSendInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CircleSendInline;

CircleSendInline.default = CircleSendInline;
